"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.prerelease = exports.patch = exports.minor = exports.major = exports.default = void 0;
const version = exports.version = "7.1.0";
const major = exports.major = Number("7");
const minor = exports.minor = Number("1");
const patch = exports.patch = Number("0");
const prerelease = exports.prerelease = undefined;
var _default = exports.default = version;